module.exports = __webpack_public_path__ + "img/mike.69256b3c.png";